<template>
<!--    <outside-click-detector @outside="toggleOpen(false)">-->
        <div class="main-search main-search--open" ref="main-search">
            <form class="main-search__form" :action="`${searchURL}`">
                <input
                    class="main-search__field"
                    :placeholder="placeholder"
                    type="text"
                    maxlength="50"
                    name="q"
                    v-model="query"
                    ref="input"
                    @input="makeSuggest"
                    @click="openSuggest"
                >
                <button type="submit" class="main-search__open d-block d-sm-none">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 18 19" fill="none">
                        <path d="M11.1931 2.74887C13.525 5.08069 13.525 8.86132 11.1931 11.1931C8.86132 13.525 5.08069 13.525 2.74887 11.1931C0.417045 8.86132 0.417045 5.08069 2.74887 2.74887C5.08069 0.417045 8.86132 0.417045 11.1931 2.74887" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.1484 11.2271L16.9984 17.1571" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <button @click.prevent="toggleOpen(!isOpen)" type="button" class="main-search__open d-none d-sm-block">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 18 19" fill="none">
                        <path d="M11.1931 2.74887C13.525 5.08069 13.525 8.86132 11.1931 11.1931C8.86132 13.525 5.08069 13.525 2.74887 11.1931C0.417045 8.86132 0.417045 5.08069 2.74887 2.74887C5.08069 0.417045 8.86132 0.417045 11.1931 2.74887" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M11.1484 11.2271L16.9984 17.1571" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </form>
            <div :class="suggestResultClassNames" v-if="suggestData">
                <suggest-result-header :suggest-data="suggestData"></suggest-result-header>
            </div>
        </div>
<!--    </outside-click-detector>-->
</template>

<script>

import { ajaxRequest } from '../../../services/ajax-service';
import OutsideClickDetector from '../../dom-helpers/outside-click-detector';
import { globalErrorHandler } from '../../../services/error-handling';

const START_SUGGEST_SYMBOLS = 2;

let REQUEST_TIMER = '';
const REQUEST_TIMEOUT = 1000;

export default {
    name: 'main-search',

    components: { OutsideClickDetector },

    props: {
        placeholder: {
            type: String,
            default: 'Поиск по сайту',
        },

        suggestComponent: {
            type: String,
            default: 'suggest-result-header',
        },
    },

    data() {
        return {
            query: '',
            searchURL: '/search/',
            isOpen: true,

            suggestData: null,
            isSuggestLoading: false,
            isOpenSuggest: false,
        };
    },

    methods: {
        isOpenWatcher(value) {
            if (value) {
                this.$refs.input.focus();
            } else {
                this.query = '';
            }
        },

        toggleOpen(flag) {
            this.isOpen = flag;
        },

        // onInput() {
        //     const query = new FormData();
        //     query.append('query', this.query);
        //
        //     ajaxRequest('/api/search/', { query })
        //         .then((response) => { this.searchURL = response.data.data.URL; })
        //         .catch((error) => console.log(error));
        // },

        openSuggest() {
            document.addEventListener('click', this.missclickHandler);

            if (this.query.length > START_SUGGEST_SYMBOLS) {
                this.isOpenSuggest = true;
            }
        },

        makeSuggest() {
            if (!this.suggestComponent) return; // Если нет компонента для вывода подсказки, то ничего и не выводим

            clearTimeout(REQUEST_TIMER); // сброс таймера

            if (this.query.length > START_SUGGEST_SYMBOLS) {
                REQUEST_TIMER = setTimeout(() => this.request(), REQUEST_TIMEOUT); // Отправляем запрос
            } else {
                this.isOpenSuggest = false; // Скрываем подсказку
            }
        },

        request() {
            this.isSuggestLoading = true; // Вешаем лоадер на саджест

            const query = new FormData();
            query.append('query', this.query);

            ajaxRequest('/api/search/', { query })
                .then((response) => this.successHandler(response))
                .catch((error) => this.errorHandler(error))
                .finally(this.finallyHandler);
        },

        successHandler({ data }) {
            this.isOpenSuggest = true;

            this.suggestData = data.data;

            if (Array.isArray(data.data)) {
                this.suggestData = {
                    ITEMS: [],
                };
            }
        },

        errorHandler(error) {
            globalErrorHandler(error);
            this.isOpenSuggest = false;
        },

        finallyHandler() {
            this.isSuggestLoading = false; // Снимаем лоадер с саджеста
        },

        missclickHandler(evt) {
            const isClickInside = this.$refs['main-search'].contains(evt.target);

            if (!isClickInside) {
                this.isOpenSuggest = false;
                document.removeEventListener('click', this.missclickHandler);
            }
        }
    },

    computed: {
        classNames() {
            return {
                'main-search': true,
                'main-search--open': this.isOpen,
            };
        },

        suggestResultClassNames() {
            return {
                'suggest-search__result': true,
                'suggest-search__result--main': true,
                'suggest-search__result--open': this.isOpenSuggest,
                'suggest-search__result--loading': this.isSuggestLoading,
            };
        },
    },

    watch: {
        isOpen: 'isOpenWatcher',
    },

    created() {
        document.addEventListener('click', this.missclickHandler);
    },
};
</script>
